module.exports = __webpack_public_path__ + "media/images/features/6/schedule-4-0c11befb89406e2222302f3d396c4218.png";